import {Typography} from '@mui/material';

export default function SessionCompleteHeader() {
  return (
    <Typography variant="h4" sx={{fontWeight: 600, textAlign: 'center'}}>
      Session Complete! 🎉
    </Typography>
  );
}
